import React from "react";

const NoEvent = () => {
  return (
    <div className="s-flex s-justify-center s-items-center s-py-36">
      <div className="s-py-6 s-px-7 s-bg-white dark:s-bg-black-800 s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark s-text-base s-rounded-5px s-leading-tight s-shadow-2sm">
        <div
          alt
          className="s-icon-empty s-text-40px s-text-black-300 dark:s-opacity-30 s-m-auto s-mb-2.5"
        />
        <div>No Event</div>
      </div>
    </div>
  );
};

export default NoEvent;
